"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "escape", {
  enumerable: true,
  get: function get() {
    return _html.escape;
  }
});
_Object$defineProperty(exports, "escapeSync", {
  enumerable: true,
  get: function get() {
    return _html.escapeSync;
  }
});
_Object$defineProperty(exports, "filter", {
  enumerable: true,
  get: function get() {
    return _html.filter;
  }
});
_Object$defineProperty(exports, "filterEscape", {
  enumerable: true,
  get: function get() {
    return _html.filterEscape;
  }
});
_Object$defineProperty(exports, "filterEscapeSync", {
  enumerable: true,
  get: function get() {
    return _html.filterEscapeSync;
  }
});
_Object$defineProperty(exports, "filterSync", {
  enumerable: true,
  get: function get() {
    return _html.filterSync;
  }
});
var _html = require("./html");
//# sourceMappingURL=index.js.map
